/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateBulkMetricValuesDto,
  CreateMetricValueDto,
  ErrorResponse,
  MetricValuesAggregationRequestDto,
  MetricValuesAggregationResponseDto,
  MetricValuesPaginationRequestDto,
  MetricValuesPaginationResponseDto,
} from '../models/index';
import {
    CreateBulkMetricValuesDtoFromJSON,
    CreateBulkMetricValuesDtoToJSON,
    CreateMetricValueDtoFromJSON,
    CreateMetricValueDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MetricValuesAggregationRequestDtoFromJSON,
    MetricValuesAggregationRequestDtoToJSON,
    MetricValuesAggregationResponseDtoFromJSON,
    MetricValuesAggregationResponseDtoToJSON,
    MetricValuesPaginationRequestDtoFromJSON,
    MetricValuesPaginationRequestDtoToJSON,
    MetricValuesPaginationResponseDtoFromJSON,
    MetricValuesPaginationResponseDtoToJSON,
} from '../models/index';

export interface CreateBulkMetricValuesRequest {
    createBulkMetricValuesDto: CreateBulkMetricValuesDto;
}

export interface CreateMetricValueRequest {
    createMetricValueDto: CreateMetricValueDto;
}

export interface DeleteMetricValueRequest {
    id: number;
}

export interface GetMetricValuesAggregatedRequest {
    metricValuesAggregationRequestDto: MetricValuesAggregationRequestDto;
}

export interface GetMetricValuesAggregatedByPatientIdRequest {
    patientId: string;
    metricValuesAggregationRequestDto: MetricValuesAggregationRequestDto;
}

export interface GetMetricValuesPaginatedRequest {
    metricValuesPaginationRequestDto: MetricValuesPaginationRequestDto;
    page?: number;
    pageSize?: number;
}

export interface GetMetricValuesPaginatedByPatientIdRequest {
    patientId: string;
    metricValuesPaginationRequestDto: MetricValuesPaginationRequestDto;
    page?: number;
    pageSize?: number;
}

/**
 * 
 */
export class ActivityApi extends runtime.BaseAPI {

    /**
     * Create multiple activity metric values for a patient in a single request with validation
     * Create Bulk Activity Metric Values
     */
    async createBulkMetricValuesRaw(requestParameters: CreateBulkMetricValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createBulkMetricValuesDto'] == null) {
            throw new runtime.RequiredError(
                'createBulkMetricValuesDto',
                'Required parameter "createBulkMetricValuesDto" was null or undefined when calling createBulkMetricValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/bulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBulkMetricValuesDtoToJSON(requestParameters['createBulkMetricValuesDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create multiple activity metric values for a patient in a single request with validation
     * Create Bulk Activity Metric Values
     */
    async createBulkMetricValues(requestParameters: CreateBulkMetricValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createBulkMetricValuesRaw(requestParameters, initOverrides);
    }

    /**
     * Create a single activity metric value for a patient with validation
     * Create Activity Metric Value
     */
    async createMetricValueRaw(requestParameters: CreateMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createMetricValueDto'] == null) {
            throw new runtime.RequiredError(
                'createMetricValueDto',
                'Required parameter "createMetricValueDto" was null or undefined when calling createMetricValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMetricValueDtoToJSON(requestParameters['createMetricValueDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a single activity metric value for a patient with validation
     * Create Activity Metric Value
     */
    async createMetricValue(requestParameters: CreateMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createMetricValueRaw(requestParameters, initOverrides);
    }

    /**
     * Soft delete an activity metric value for a patient (marks as deleted but preserves data)
     * Soft Delete Activity Metric Value
     */
    async deleteMetricValueRaw(requestParameters: DeleteMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteMetricValue().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Soft delete an activity metric value for a patient (marks as deleted but preserves data)
     * Soft Delete Activity Metric Value
     */
    async deleteMetricValue(requestParameters: DeleteMetricValueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteMetricValueRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve aggregated activity metric values for a patient grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Aggregated)
     */
    async getMetricValuesAggregatedRaw(requestParameters: GetMetricValuesAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesAggregationResponseDto>> {
        if (requestParameters['metricValuesAggregationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesAggregationRequestDto',
                'Required parameter "metricValuesAggregationRequestDto" was null or undefined when calling getMetricValuesAggregated().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/aggregated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesAggregationRequestDtoToJSON(requestParameters['metricValuesAggregationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesAggregationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve aggregated activity metric values for a patient grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Aggregated)
     */
    async getMetricValuesAggregated(requestParameters: GetMetricValuesAggregatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesAggregationResponseDto> {
        const response = await this.getMetricValuesAggregatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve aggregated activity metric values for a specific patient by patient ID grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Aggregated)
     */
    async getMetricValuesAggregatedByPatientIdRaw(requestParameters: GetMetricValuesAggregatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesAggregationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMetricValuesAggregatedByPatientId().'
            );
        }

        if (requestParameters['metricValuesAggregationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesAggregationRequestDto',
                'Required parameter "metricValuesAggregationRequestDto" was null or undefined when calling getMetricValuesAggregatedByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/aggregated/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesAggregationRequestDtoToJSON(requestParameters['metricValuesAggregationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesAggregationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve aggregated activity metric values for a specific patient by patient ID grouped by time interval with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Aggregated)
     */
    async getMetricValuesAggregatedByPatientId(requestParameters: GetMetricValuesAggregatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesAggregationResponseDto> {
        const response = await this.getMetricValuesAggregatedByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated list of activity metric values for a patient with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Paginated)
     */
    async getMetricValuesPaginatedRaw(requestParameters: GetMetricValuesPaginatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesPaginationResponseDto>> {
        if (requestParameters['metricValuesPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesPaginationRequestDto',
                'Required parameter "metricValuesPaginationRequestDto" was null or undefined when calling getMetricValuesPaginated().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/paginated`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesPaginationRequestDtoToJSON(requestParameters['metricValuesPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated list of activity metric values for a patient with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values (Paginated)
     */
    async getMetricValuesPaginated(requestParameters: GetMetricValuesPaginatedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesPaginationResponseDto> {
        const response = await this.getMetricValuesPaginatedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve paginated list of activity metric values for a patient by patient ID with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Paginated)
     */
    async getMetricValuesPaginatedByPatientIdRaw(requestParameters: GetMetricValuesPaginatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetricValuesPaginationResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getMetricValuesPaginatedByPatientId().'
            );
        }

        if (requestParameters['metricValuesPaginationRequestDto'] == null) {
            throw new runtime.RequiredError(
                'metricValuesPaginationRequestDto',
                'Required parameter "metricValuesPaginationRequestDto" was null or undefined when calling getMetricValuesPaginatedByPatientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/activity/metric-values/query/paginated/patients/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetricValuesPaginationRequestDtoToJSON(requestParameters['metricValuesPaginationRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetricValuesPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieve paginated list of activity metric values for a patient by patient ID with optional filtering by date range, metric, and health provider
     * Get Activity Metric Values by Patient ID (Paginated)
     */
    async getMetricValuesPaginatedByPatientId(requestParameters: GetMetricValuesPaginatedByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetricValuesPaginationResponseDto> {
        const response = await this.getMetricValuesPaginatedByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
